import React, { useState } from 'react'
 
 
import ComplianceConfigList from './ComplianceConfigList';
import ComplianceConfigForm from './ComplianceConfigForm';

const ComplianceConfig= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <ComplianceConfigForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <ComplianceConfigList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default ComplianceConfig